import { Skeleton } from 'components/Skeleton'

const BarSkeleton = ({ height }) => (
  <Skeleton variant="rectangular" className="w-[18%] rounded" height={height} />
)

const BarGraphSkeleton = () => {
  return (
    <>
      <div className="md:w-5/12 w-full p-4 sm:p-6   h-full">
        <div className="flex justify-between items-center">
          <Skeleton variant="text" width={41} height={82} />
          <Skeleton variant="rectangular" width="80%" height={48} />
        </div>
        <div className="flex items-end justify-around h-48">
          <BarSkeleton height="80%" />
          <BarSkeleton height="60%" />
          <BarSkeleton height="40%" />
          <BarSkeleton height="20%" />
        </div>
        <div className="mt-6">
          <Skeleton variant="rectangular" height={16} className="w-full mb-3" />
          <Skeleton variant="rectangular" height={16} className="w-full mb-3" />
          <Skeleton variant="rectangular" height={32} className="w-full" />
        </div>
      </div>
    </>
  )
}

function LoadingTerms(helocUpdated) {
  return (
    <div className="p-4 sm:p-6 md:p-8 ">
      <div className="p-4 mb-6 flex flex-col items-center py-10">
        <Skeleton variant="rectangular" height={44} className="mb-3 w-full" width="60%" />
        <Skeleton variant="text" height={26} width="60%" />
      </div>
      {helocUpdated ? (
        <>
          <div style={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
              <div className="mb-12 w-full flex items-center flex-col">
                <Skeleton variant="text" width="30%" className="mb-2" height={19} />
                <Skeleton variant="text" width="20%" className="mb-4" height={31} />
              </div>
              <div className="mb-12 w-full flex items-center flex-col">
                <Skeleton variant="text" width="30%" className="mb-2" height={19} />
                <Skeleton variant="text" width="20%" className="mb-4" height={31} />
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
              <div className="mb-12 w-full flex items-center flex-col">
                <Skeleton variant="text" width="30%" className="mb-2" height={19} />
                <Skeleton variant="text" width="20%" className="mb-4" height={31} />
              </div>
              <div className="mb-12 w-full flex items-center flex-col">
                <Skeleton variant="text" width="30%" className="mb-2" height={19} />
                <Skeleton variant="text" width="20%" height={31} />
              </div>
            </div>
          </div>
        </>
      ) : null}
      <div className="flex flex-col  py-2 md:flex-row md:gap-6">
        {helocUpdated ? null : (
          <>
            <div className="md:w-7/12 w-full mb-6 md:mb-0 p-4 sm:p-6   h-full">
              <div className="mb-12">
                <Skeleton variant="text" width="30%" className="mb-2" height={19} />
                <Skeleton variant="text" width="20%" className="mb-4" height={31} />
              </div>
              <div className="mb-12">
                <Skeleton variant="text" width="30%" className="mb-2" height={19} />
                <Skeleton variant="text" width="20%" className="mb-4" height={31} />
              </div>
              <div className="mb-12">
                <Skeleton variant="text" width="30%" className="mb-2" height={19} />
                <Skeleton variant="text" width="20%" className="mb-4" height={31} />
              </div>
              <div>
                <Skeleton variant="text" width="30%" className="mb-2" height={19} />
                <Skeleton variant="text" width="20%" height={31} />
              </div>
            </div>
          </>
        )}
        {helocUpdated ? (
          <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            <BarGraphSkeleton />
          </div>
        ) : (
          <BarGraphSkeleton />
        )}
      </div>
    </div>
  )
}

export { LoadingTerms }
export default LoadingTerms
